import { useDispatch, useSelector } from 'react-redux';

import { updateTeamNavigation } from '@atom/actions/teamNavigationActions';
import { Section } from '@atom/components/teamPortal/TeamContext';
import { RootState } from '@atom/types/store';

export const INIT_PAGINATION = { page: 1, limit: 25 };

export interface TeamNavigation {
  expanded: Set<Section>;
  payPeriodWeeks: number[][];
}

export const INITIAL_TEAM_NAVIGATION: TeamNavigation = {
  expanded: new Set([Section.DIRECTORY, Section.PEOPLE, Section.TIME_SHEET]),
  payPeriodWeeks: [],
};

interface Data {
  // teamNavigation saves the state of the teams portal UI
  teamNavigation: TeamNavigation;
  setTeamNavigation: (input: Partial<TeamNavigation>) => void;
}

export const useTeamNavigation = (): Data => {
  const dispatch = useDispatch();
  const teamNavigation = useSelector(
    (state: RootState) => state.teamNavigation,
  );

  const setTeamNavigation = (newTeamNavigation: Partial<TeamNavigation>) => {
    dispatch(updateTeamNavigation(newTeamNavigation));
  };

  return {
    teamNavigation,
    setTeamNavigation,
  };
};
